import { useState } from "react";
import { Badge } from "@/components/ui/badge";

export const STATE_META = {
  with_developer: { label: "With Developer", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  handover_pending: { label: "Handover Pending", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  handed_over: { label: "Handed Over", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" }) : "");

export function SocietyStateBadge({ s, testid }) {
  const m = STATE_META[s.state] || STATE_META.with_developer;
  return (
    <Badge variant="outline" className={m.cls} data-testid={testid}>
      {m.label}{s.state === "handed_over" && s.handover_date ? ` · ${fmtDate(s.handover_date)}` : ""}
    </Badge>
  );
}

export function useForm(initial) {
  const [form, setForm] = useState(initial);
  const bind = (k) => ({ value: form[k] ?? "", onChange: (e) => setForm((f) => ({ ...f, [k]: e.target.value })) });
  return { form, setForm, bind };
}
